import axios from "axios";
import { isAuthUrl, refreshAccessToken } from "./session";
export const getToken = () => {
  return localStorage.getItem("access_token");
};

const axiosInstance = axios.create({
  baseURL: "https://go.7cut.video",
  headers: {},
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Don't set Content-Type for FormData
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const status = error.response?.status;
    const url = error.config?.url || error.request?.responseURL || "";

    if (status === 401 && !isAuthUrl(url) && !error.config?._retried) {
      error.config._retried = true;
      try {
        const token = await refreshAccessToken();
        error.config.headers = {
          ...error.config.headers,
          Authorization: `Bearer ${token}`,
        };
        return axiosInstance(error.config);
      } catch (refreshError) {
        return Promise.reject(error);
      }
    }

    if (
      status === 404 &&
      !url.includes("/project/role") &&
      url.includes("/project") &&
      !url.includes("/version") &&
      !url.includes("move")
    ) {
      window.location.href = `${window.location.origin}/error/access`;
      return Promise.reject(error);
    }

    if (
      status === 404 &&
      !url.includes("/project/role") &&
      !url.includes("/legal-document")
    ) {
      if (
        (url.includes("version") && url.includes("project")) ||
        url.includes("move")
      ) {
        // игнорируем
      } else {
        window.location.href = `${window.location.origin}/error/404`;
      }
    }

    if (status === 500) {
      window.location.href = `${window.location.origin}/error/500`;
    }

    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use(
//   (config) => {
//     return config;
//   },
//   (error) => {
//     console.log("Error:", error);
//     if (
//       error.response.status === 404 &&
//       !error.request.responseURL.includes("/project/role") &&
//       error.request.responseURL.includes("/project") &&
//       !error.request.responseURL.includes("/version")
//     ) {
//       window.location.href = `${window.location.origin}/error/access`;
//       return;
//     }
//     if (
//       error.response.status === 404 &&
//       !error.request.responseURL.includes("/project/role") &&
//       !error.request.responseURL.includes("/legal-document")
//     ) {
//       if (
//         error.request.responseURL.includes("version") &&
//         error.request.responseURL.includes("project")
//       ) {
//       } else {
//         window.location.href = `${window.location.origin}/error/404`;
//       }
//     }

//     if (error.response.status === 500) {
//       window.location.href = `${window.location.origin}/error/500`;
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
